import {
  FETCH_PAYMENT_METHODS,
  FETCH_PAYMENT_METHODS_SUCCESS,
  FETCH_PAYMENT_METHODS_FAILED,
  FETCH_MERCADOPAGO_CARDS,
  UPDATE_WALLET_BALANCE,
  UPDATE_WALLET_BALANCE_SUCCESS,
  UPDATE_WALLET_BALANCE_FAILED,
  CLEAR_PAYMENT_MESSAGES,
} from "../store/types";
import store from "../store/store";
import base64 from "react-native-base64";
import AccessKey from "../other/AccessKey";
import { updateProfile } from "./authactions";
import { firebase } from "../config/firebase.client";
import { onValue, get, update, push } from "firebase/database";
import { RequestPushMsg } from "../other/NotificationFunctions";


export const fetchPaymentMethods = () => (dispatch) => {
  const { config } = firebase;

  dispatch({
    type: FETCH_PAYMENT_METHODS,
    payload: null,
  });

  const settings = store.getState().settingsdata.settings;
  let host =
    window &&
      window.location &&
      settings.CompanyWebsite === window.location.origin
      ? window.location.origin
      : `https://${config.projectId}.web.app`;
  let url = `${host}/get_providers`;
  fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.length > 0) {
        dispatch({
          type: FETCH_PAYMENT_METHODS_SUCCESS,
          payload: responseJson,
        });
      } else {
        dispatch({
          type: FETCH_PAYMENT_METHODS_FAILED,
          payload:
            store.getState().languagedata.defaultLanguage.no_provider_found,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: FETCH_PAYMENT_METHODS_FAILED,
        payload:
          store.getState().languagedata.defaultLanguage.provider_fetch_error +
          ": " +
          error.toString(),
      });
    });
};

export const removeMercadopagoCustomerCards = (customerId, Id, cards) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://us-central1-${config.projectId}.cloudfunctions.net/mercadopago-costumer_remove_card?id=${Id}&customerId=${customerId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " + base64.encode(config.projectId + ":" + AccessKey),
      },
    })
      .then(() => {
        const updatedCards = cards.filter(card => card.id !== Id);
        dispatch({
          type: FETCH_MERCADOPAGO_CARDS,
          payload: updatedCards,
        });
        return true
      })
      .catch((error) => {

        dispatch({
          type: FETCH_MERCADOPAGO_CARDS,
          payload: [],
        });
        reject("fetch Call Error");
      });
  });
};

export const getMercadopagoCustomerCards = (id) => (dispatch) => {
  dispatch({
    type: FETCH_MERCADOPAGO_CARDS,
    payload: null,
  });

  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://us-central1-${config.projectId}.cloudfunctions.net/mercadopago-costumer_get_card?customerId=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " + base64.encode(config.projectId + ":" + AccessKey),
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        dispatch({
          type: FETCH_MERCADOPAGO_CARDS,
          payload: responseJson,
        });
      })
      .catch((error) => {
        console.log(error);
        reject("fetch Call Error");
      });
  });
};


export const checkMercadopagoCustomerCards = (user) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;


    fetch(`https://us-central1-${config.projectId}.cloudfunctions.net/mercadopago-costumer?customerId=${user.customerId}&email=${user.email}&driverType=${user.usertype}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " + base64.encode(config.projectId + ":" + AccessKey),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.text().then((id) => {
          try {

            dispatch(updateProfile({ customerId: id }))
            resolve(id);
          } catch (error) {
            console.error('Erro ao fazer parse do JSON:', error);
            reject('JSON Parse Error');
          }
        });
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
        reject('fetch Call Error');
      });
  });
};


export const clearMessage = () => (dispatch) => {
  dispatch({
    type: CLEAR_PAYMENT_MESSAGES,
    payload: null,
  });
};

export const savePaymentSuccess = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://${config.projectId}.web.app/stripe-completecheckout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " + base64.encode(config.projectId + ":" + AccessKey),
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        console.log(error);
        reject("fetchPlacesAutocomplete Call Error");
      });
  });
};


export const createPaymentIntent = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const { config } = firebase;
    fetch(`https://${config.projectId}.web.app/stripe-paymentsheet`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " + base64.encode(config.projectId + ":" + AccessKey),
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        console.log(error);
        reject("fetchPlacesAutocomplete Call Error");
      });
  });
};

export const addToWallet = (uid, amount) => async (dispatch) => {
  const { walletHistoryRef, singleUserRef, settingsRef } = firebase;

  dispatch({
    type: UPDATE_WALLET_BALANCE,
    payload: null,
  });

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  onValue(
    singleUserRef(uid),
    (snapshot) => {
      if (snapshot.val()) {
        let walletBalance = parseFloat(snapshot.val().walletBalance);
        const pushToken = snapshot.val().pushToken;
        walletBalance = parseFloat(
          (parseFloat(walletBalance) + parseFloat(amount)).toFixed(
            settings.decimal
          )
        );
        let details = {
          type: "Credit",
          amount: parseFloat(amount),
          date: new Date().getTime(),
          txRef: "AdminCredit",
        };
        update(singleUserRef(uid), { walletBalance: walletBalance })
          .then(() => {
            push(walletHistoryRef(uid), details)
              .then(() => {
                dispatch({
                  type: UPDATE_WALLET_BALANCE_SUCCESS,
                  payload: null,
                });
              })
              .catch((error) => {
                dispatch({
                  type: UPDATE_WALLET_BALANCE_FAILED,
                  payload: error.code + ": " + error.message,
                });
              });
            if (pushToken) {
              RequestPushMsg(pushToken, {
                title:
                  store.getState().languagedata.defaultLanguage
                    .notification_title,
                msg: store.getState().languagedata.defaultLanguage
                  .wallet_updated,
                screen: "Wallet",
              });
            }
          })
          .catch((error) => {
            dispatch({
              type: UPDATE_WALLET_BALANCE_FAILED,
              payload: error.code + ": " + error.message,
            });
          });
      }
    },
    { onlyOnce: true }
  );
};

export const withdrawBalance = (profile, amount) => async (dispatch) => {
  const { withdrawRef } = firebase;

  dispatch({
    type: UPDATE_WALLET_BALANCE,
    payload: null,
  });

  push(withdrawRef, {
    uid: profile.uid,
    name: profile.firstName + " " + profile.lastName,
    amount: parseFloat(amount),
    date: new Date().getTime(),
    bankName: profile.bankName ? profile.bankName : "",
    bankCode: profile.bankCode ? profile.bankCode : "",
    bankAccount: profile.bankAccount ? profile.bankAccount : "",
    processed: false,
  });
};